var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    transform: "matrix(-1 0 0 1 56 0)",
    fill: "url(#paint0_linear_422_1397)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_422_1397)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0297 16.7098C20.9756 17.7674 17.7674 20.9755 16.7098 25.0297C15.7227 24.7212 15 23.8047 15 22.7118V17.4237C15 16.084 16.0841 15 17.4237 15H22.7118C23.8047 15 24.7213 15.7227 25.0297 16.7098ZM41 17.4238V22.7119C41 23.8047 40.2773 24.7213 39.2902 25.0298C38.2326 20.9756 35.0245 17.7675 30.9703 16.7099C31.2788 15.7228 32.1953 15.0001 33.2882 15.0001H38.5763C39.916 15.0001 41 16.0841 41 17.4238ZM22.7118 40.9985C23.8047 40.9985 24.7213 40.2758 25.0297 39.2887C20.9756 38.2311 17.7674 35.0229 16.7098 30.9688C15.7227 31.2772 15 32.1938 15 33.2867V38.5748C15 39.9144 16.0841 40.9985 17.4237 40.9985H22.7118ZM41 33.2867V38.5748C41 39.9144 39.9159 40.9985 38.5763 40.9985H33.2882C32.1953 40.9985 31.2787 40.2758 30.9702 39.2887C35.0245 38.2311 38.2325 35.0229 39.2901 30.9688C40.2772 31.2772 41 32.1938 41 33.2867ZM17.644 28.0004C17.644 22.2905 22.2896 17.6445 27.9999 17.6445C33.7101 17.6445 38.3557 22.2905 38.3557 28.0004C38.3557 33.7102 33.7101 38.3562 27.9999 38.3562C22.2896 38.3562 17.644 33.7102 17.644 28.0004ZM33.288 30.4241C34.145 30.4241 34.1192 29.1021 33.288 29.1021H28.188L29.2896 26.8987H33.288C34.1441 26.8987 34.1359 25.5767 33.288 25.5767H29.9506L31.2352 23.0075C31.6191 22.2397 30.4232 21.676 30.0526 22.4171L28.4728 25.5767H22.7118C21.851 25.5767 21.8726 26.8987 22.7118 26.8987H27.8118L26.7101 29.1021H22.7118C21.8552 29.1021 21.8766 30.4241 22.7118 30.4241H26.0491L24.7645 32.9932C24.3792 33.764 25.5698 34.3384 25.9471 33.5837L27.5269 30.4241H33.288Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_422_1397",
    x: 5,
    y: 9,
    width: 46,
    height: 45.9985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.25 0 0 0 0 0.07 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_422_1397"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_422_1397",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_422_1397",
    x1: 52,
    y1: 49.5,
    x2: 1,
    y2: 6.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FF57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13AC87",
    stopOpacity: 0.46
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.686ec24de46eb32518f7ea0d61df5448.svg";
export { ForwardRef as ReactComponent };